import { useParams } from 'react-router-dom';
import RealTimePanel from '../../../components/RealTimePanel';

export default function RealtimeRoute() {
  const { botId } = useParams<{ botId: string }>();
  if (!botId) return null;
  return <RealTimePanel botId={botId} />;
}
